import { render, staticRenderFns } from "./gatewaymodal.vue?vue&type=template&id=40addbd5&scoped=true"
import script from "./gatewaymodal.vue?vue&type=script&lang=js"
export * from "./gatewaymodal.vue?vue&type=script&lang=js"
import style0 from "./gatewaymodal.vue?vue&type=style&index=0&id=40addbd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40addbd5",
  null
  
)

export default component.exports